import { memo, useMemo, useState } from "react"
import { StyleSheet, View, Pressable, Text, Modal } from "react-native"
import { Path, Svg } from "react-native-svg"
import { Button } from "src/components/parts/buttons/Button"
import { Colors } from "src/constants/Colors"
import { RemoveIcon } from "../icons/RemoveIcon"
import { useCheckPCScreen } from "src/hooks/useCheckPCScreen"
import { useAsyncSelector } from "src/hooks/useAsyncSelector"
import { selectedMyOrganizationSelector } from "src/recoil/selectors/organization/selectedMyOrganizationSelector"
import { matchingOtherProfileSelectorFamily } from "src/recoil/selectors/matching/matchingOtherProfileSelectorFamily"
import { useNavigation } from "@react-navigation/native"
import { Screens } from "src/constants/Screens"
import { AgreeMatchingTermModal } from "src/screens/matching/AgreeMatchingTermModal"
import { useRecoilState } from "recoil"
import { acceptMatchingTermState } from "src/recoil/atoms/matching/acceptMatchingTermState"
import { accountSelector } from "src/recoil/selectors/account/accountSelector"
import { latestTermsState } from "src/recoil/atoms/account/latestTermsState"

type Props = {
  onPress: () => void
  closeCallback?: () => void
}

const MatchingCreateIcon = ({ fill = Colors.white3 }: { fill: string }) => (
  <Svg width="31" height="28" viewBox="0 0 31 28" fill="none">
    <Path
      d="M4.60828 24.3945C4.09253 24.3945 3.64555 24.2078 3.26735 23.8343C2.88912 23.4609 2.70001 23.0158 2.70001 22.499V6.29183C2.70001 6.09856 2.73447 5.90322 2.80339 5.70579C2.87233 5.50839 2.97015 5.32531 3.09686 5.15655L5.01438 2.63306C5.17354 2.40612 5.3833 2.2263 5.64365 2.0936C5.90401 1.96089 6.18991 1.89453 6.50136 1.89453H21.3524C21.6639 1.89453 21.9519 1.96037 22.2166 2.09204C22.4812 2.22371 22.7004 2.40445 22.8742 2.63426L24.8263 5.18223C24.9376 5.3525 25.0277 5.53824 25.0966 5.73945C25.1656 5.94066 25.2 6.13763 25.2 6.33036V14.0445H23.7314V6.86711H18.6105V16.4104L18.0891 16.9318L13.95 14.8731L9.31264 17.2001V6.86711H4.16402V22.5195C4.16402 22.6394 4.20255 22.7379 4.27962 22.8149C4.35668 22.892 4.45515 22.9305 4.57502 22.9305H14.7578V24.3945H4.60828Z"
      fill={fill}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.7373 15.1049C24.5618 15.0328 24.374 14.9959 24.1843 14.9961C23.8017 14.9962 23.4342 15.1475 23.1628 15.4177C22.8911 15.6881 22.7379 16.0554 22.7379 16.4391V19.7135H19.4475C19.0646 19.7135 18.6967 19.8649 18.425 20.1353C18.1532 20.4058 18 20.7733 18 21.1572C18 21.541 18.1532 21.9085 18.425 22.179C18.6967 22.4494 19.0646 22.6008 19.4475 22.6008H22.7404V25.8715C22.7404 26.2553 22.8936 26.6228 23.1654 26.8933C23.4371 27.1637 23.805 27.3151 24.1879 27.3151C24.5709 27.3151 24.9388 27.1637 25.2104 26.8933C25.4822 26.6228 25.6354 26.2553 25.6354 25.8715V22.5983H28.9246C29.3076 22.5983 29.6754 22.4469 29.9471 22.1765C30.2189 21.906 30.3721 21.5385 30.3721 21.1547C30.3721 20.7709 30.2189 20.4033 29.9471 20.1328C29.6754 19.8624 29.3076 19.7111 28.9246 19.7111H25.6329V16.4391C25.6329 16.249 25.5953 16.0608 25.5222 15.8854C25.4491 15.71 25.3421 15.5508 25.2073 15.4169C25.0726 15.283 24.9129 15.1771 24.7373 15.1049Z"
      fill="white"
    />
    <Path
      d="M24.1843 14.9961L24.1845 15.4961L24.1849 15.4961L24.1843 14.9961ZM24.7373 15.1049L24.5472 15.5674L24.5472 15.5674L24.7373 15.1049ZM23.1628 15.4177L22.81 15.0633L22.81 15.0633L23.1628 15.4177ZM22.7379 19.7135V20.2135H23.2379V19.7135H22.7379ZM18.425 20.1353L18.0723 19.7809H18.0723L18.425 20.1353ZM18.425 22.179L18.7777 21.8246L18.7777 21.8246L18.425 22.179ZM22.7404 22.6008H23.2404V22.1008H22.7404V22.6008ZM23.1654 26.8933L22.8127 27.2477L22.8127 27.2477L23.1654 26.8933ZM25.2104 26.8933L25.5631 27.2477H25.5631L25.2104 26.8933ZM25.6354 22.5983V22.0983H25.1354V22.5983H25.6354ZM29.9471 22.1765L29.5944 21.8221L29.5944 21.8221L29.9471 22.1765ZM29.9471 20.1328L29.5944 20.4872V20.4872L29.9471 20.1328ZM25.6329 19.7111H25.1329V20.2111H25.6329V19.7111ZM25.5222 15.8854L25.9837 15.6931V15.6931L25.5222 15.8854ZM25.2073 15.4169L24.8549 15.7716L24.8549 15.7716L25.2073 15.4169ZM24.1849 15.4961C24.3092 15.4959 24.4323 15.5202 24.5472 15.5674L24.9273 14.6424C24.6914 14.5455 24.4387 14.4958 24.1838 14.4961L24.1849 15.4961ZM23.5155 15.7721C23.693 15.5954 23.9337 15.4962 24.1845 15.4961L24.1842 14.4961C23.6698 14.4963 23.1754 14.6997 22.81 15.0633L23.5155 15.7721ZM23.2379 16.4391C23.2379 16.1888 23.3378 15.9489 23.5155 15.7721L22.81 15.0633C22.4444 15.4273 22.2379 15.9221 22.2379 16.4391H23.2379ZM23.2379 19.7135V16.4391H22.2379V19.7135H23.2379ZM19.4475 20.2135H22.7379V19.2135H19.4475V20.2135ZM18.7777 20.4897C18.9555 20.3128 19.1964 20.2135 19.4475 20.2135V19.2135C18.9327 19.2135 18.4379 19.417 18.0723 19.7809L18.7777 20.4897ZM18.5 21.1572C18.5 20.9067 18.6 20.6666 18.7777 20.4897L18.0723 19.7809C17.7065 20.145 17.5 20.64 17.5 21.1572H18.5ZM18.7777 21.8246C18.6 21.6477 18.5 21.4076 18.5 21.1572H17.5C17.5 21.6744 17.7065 22.1693 18.0723 22.5334L18.7777 21.8246ZM19.4475 22.1008C19.1964 22.1008 18.9555 22.0015 18.7777 21.8246L18.0723 22.5334C18.4379 22.8973 18.9327 23.1008 19.4475 23.1008V22.1008ZM22.7404 22.1008H19.4475V23.1008H22.7404V22.1008ZM23.2404 25.8715V22.6008H22.2404V25.8715H23.2404ZM23.5181 26.539C23.3404 26.362 23.2404 26.1219 23.2404 25.8715H22.2404C22.2404 26.3887 22.4469 26.8836 22.8127 27.2477L23.5181 26.539ZM24.1879 26.8151C23.9368 26.8151 23.6959 26.7158 23.5181 26.539L22.8127 27.2477C23.1784 27.6116 23.6731 27.8151 24.1879 27.8151V26.8151ZM24.8577 26.539C24.68 26.7158 24.4391 26.8151 24.1879 26.8151V27.8151C24.7027 27.8151 25.1975 27.6116 25.5631 27.2477L24.8577 26.539ZM25.1354 25.8715C25.1354 26.1219 25.0355 26.362 24.8577 26.539L25.5631 27.2477C25.929 26.8836 26.1354 26.3887 26.1354 25.8715H25.1354ZM25.1354 22.5983V25.8715H26.1354V22.5983H25.1354ZM28.9246 22.0983H25.6354V23.0983H28.9246V22.0983ZM29.5944 21.8221C29.4167 21.999 29.1757 22.0983 28.9246 22.0983V23.0983C29.4394 23.0983 29.9342 22.8948 30.2998 22.5309L29.5944 21.8221ZM29.8721 21.1547C29.8721 21.4051 29.7722 21.6452 29.5944 21.8221L30.2998 22.5309C30.6656 22.1668 30.8721 21.6719 30.8721 21.1547H29.8721ZM29.5944 20.4872C29.7722 20.6642 29.8721 20.9042 29.8721 21.1547H30.8721C30.8721 20.6375 30.6656 20.1425 30.2998 19.7785L29.5944 20.4872ZM28.9246 20.2111C29.1757 20.2111 29.4167 20.3103 29.5944 20.4872L30.2998 19.7785C29.9342 19.4145 29.4394 19.2111 28.9246 19.2111V20.2111ZM25.6329 20.2111H28.9246V19.2111H25.6329V20.2111ZM25.1329 16.4391V19.7111H26.1329V16.4391H25.1329ZM25.0607 16.0777C25.1084 16.1923 25.1329 16.3151 25.1329 16.4391H26.1329C26.1329 16.183 26.0822 15.9294 25.9837 15.6931L25.0607 16.0777ZM24.8549 15.7716C24.943 15.8591 25.0129 15.9632 25.0607 16.0777L25.9837 15.6931C25.8853 15.4568 25.7411 15.2425 25.5598 15.0623L24.8549 15.7716ZM24.5472 15.5674C24.6622 15.6146 24.7668 15.684 24.8549 15.7716L25.5598 15.0623C25.3785 14.8821 25.1635 14.7395 24.9273 14.6424L24.5472 15.5674Z"
      fill="#F0830E"
    />
  </Svg>
)

export const MatchingListFooter = memo<Props>(({ onPress }) => {
  const nav = useNavigation()
  const { value: account } = useAsyncSelector(accountSelector)
  const [agreeTerm, setAgreeTerm] = useRecoilState(acceptMatchingTermState)
  const { value: selectedMyTeam } = useAsyncSelector(selectedMyOrganizationSelector)
  const teamId = useMemo(() => selectedMyTeam?.id, [selectedMyTeam])
  const { value: latestTerms } = useAsyncSelector(latestTermsState)
  const { value: matchingMyProfile } = useAsyncSelector(
    matchingOtherProfileSelectorFamily({ otherTeamId: teamId, myTeamId: teamId })
  )
  const isPCScreen = useCheckPCScreen()
  const [visible, setVisible] = useState(false)

  const handleClose = () => setVisible(false)
  const gotoSetupProfile = () => {
    setVisible(false)
    nav.navigate(Screens.CreateOrEditMatchingProfile, {
      matchingProfile: matchingMyProfile,
      id: matchingMyProfile?.id ?? selectedMyTeam?.id ?? "",
      selectedMyTeam: selectedMyTeam,
    })
  }

  const handlePress = () => {
    if (!account?.matchingTermsAgreedAt || account?.agreedMatchingTermsVersion !== latestTerms?.matching.version) {
      setAgreeTerm(false)
    } else if (!matchingMyProfile) {
      setVisible(true)
    } else {
      onPress()
    }
  }

  return (
    <>
      <AgreeMatchingTermModal agreeTermProp={agreeTerm} />
      <ProfileSetupModal visible={visible} handleClose={handleClose} goToSetupProfile={gotoSetupProfile} />
      <View style={styles.container}>
        <Button onPress={handlePress} style={styles.button}>
          <MatchingCreateIcon fill={Colors.white3} />
          <Text style={styles.label}>作成</Text>
        </Button>
      </View>
    </>
  )
})

type ProfileSetupProps = {
  visible: boolean
  handleClose: () => void
  goToSetupProfile: () => void
}
export const ProfileSetupModal = ({ visible, handleClose, goToSetupProfile }: ProfileSetupProps) => {
  const isPCScreen = useCheckPCScreen()
  return (
    <Modal animationType="fade" transparent={true} visible={visible} onRequestClose={handleClose}>
      <View style={styles.centeredView}>
        <View style={styles.modalContainer}>
          <View style={[styles.header, isPCScreen && { paddingBottom: 16 }]}>
            <Button onPress={handleClose}>
              <RemoveIcon fill={Colors.orange} />
            </Button>
            <Text style={[styles.headerLabel, styles.centerLabel]}>警告</Text>
          </View>
          {isPCScreen ? (
            <>
              <Text style={[styles.headerLabel, styles.centerLabel]}>{"マッチング用プロフィールが設定されていません。"}</Text>
              <Text style={[styles.headerLabel, styles.paddingView]}>
                募集作成するにはマッチング用プロフィールを設定してください。
              </Text>
            </>
          ) : (
            <View style={styles.paddingView}>
              <Text style={[styles.headerLabel]}>{"マッチング用プロフィールが\n設定されていません。"}</Text>
              <Text style={[styles.headerLabel, { paddingTop: 16 }]}>募集作成するには</Text>
              <Text style={[styles.headerLabel]}>マッチング用プロフィールを</Text>
              <Text style={[styles.headerLabel]}>設定してください。</Text>
            </View>
          )}
          <Pressable style={[styles.footerButton]} onPress={goToSetupProfile}>
            <Text style={styles.footerButtonText}>プロフィールを設定</Text>
          </Pressable>
        </View>
      </View>
    </Modal>
  )
}

export const MatchingListFooterMargin = memo(() => {
  return <View style={[styles.margin]} pointerEvents="none" />
})
export const MatchingListFooterLarge = memo<Props>(({ onPress }) => {
  return (
    <View style={styles.containerLarge}>
      <Button onPress={onPress} style={styles.button}>
        <MatchingCreateIcon fill={Colors.white3} />
        <Text style={styles.label}>作成</Text>
      </Button>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    bottom: 32,
    right: 16,
    borderRadius: 40,
    borderWidth: 1,
    borderColor: Colors.reddishGrey,
  },
  modalContainer: {
    margin: 20,
    backgroundColor: "white",
    borderRadius: 8,
    padding: 25,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
  header: {
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
  },
  centerLabel: {
    flex: 1,
  },
  headerLabel: {
    paddingVertical: 2,
    fontWeight: "bold",
    fontSize: 18,
    textAlign: "center",
  },
  paddingView: {
    paddingVertical: 20,
  },
  footerButton: {
    width: 180,
    padding: 8,
    height: 36,
    borderRadius: 18,
    backgroundColor: Colors.orange,
    marginBottom: 16,
  },
  footerButtonText: {
    color: Colors.white3,
    textAlign: "center",
    fontWeight: "bold",
  },
  containerLarge: {
    position: "absolute",
    bottom: "10%",
    right: "5%",
    color: "red",
  },
  button: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    height: 80,
    backgroundColor: Colors.orange,
    gap: 4,
    borderColor: Colors.white3,
    borderRadius: 40,
    borderWidth: 4,
  },
  label: {
    color: Colors.white3,
    fontWeight: "700",
  },
  margin: {
    height: 120,
  },
})
